import { axiosInstance } from './axiosInstance'

const dataSet = async ({ cmsPATH, dataName, setName }) => {
  try {
    const url = `${cmsPATH}${dataName}.json`

    const { data } = await axiosInstance.get(url, {
      params: {
        _: Date.now()
      }
    })

    if (data) window.LIVESTATION[setName.toUpperCase()] = data
  } catch (e) {
    /* eslint no-console: 0 */
    console.log(e)
  }
}

export const initDataSet = async () => {
  try {
    window.LIVESTATION = window.LIVESTATION || {}

    // TOP,一覧ページの場合、全おすすめ配信の情報が入ったjsonを取得
    await dataSet({
      cmsPATH: window.CMSPATHMAINCONTENT,
      dataName: 'shop',
      setName: 'MAINCONTENT'
    })

    await dataSet({
      cmsPATH: window.CMSPATHMAINCONTENT,
      dataName: 'product',
      setName: 'PRODUCTS'
    })

  } catch (error) {
    /* eslint no-console: 0 */
    console.log(error)
  }
}
